import type { Theme } from '@mui/material';

export const styles = {
  sliderLabels: {
    justifyContent: 'space-between',
  },
  sliderValue: (theme: Theme) => ({
    color: theme.colors.primary[600],
    display: 'inline',
  }),
  slider: (theme: Theme) => ({
    height: '0.75rem',

    '.MuiSlider-rail': {
      bgcolor: theme.colors.neutral[100],
    },
  }),
};
